/* eslint-disable prettier/prettier */
import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../../../redux/configureStore';
import { getClients } from '../../../../../../redux/fetchActions/legadoPage/clientsApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import SetAccountType from './components/setAccountType';
import SetFinalDate from './components/setFinalDate';
import SetOwnership from './components/SetOwnership';
import SetPartner from './components/SetPartner';
import SetStatus from './components/SetStatus';

export function ClientsFilter() {
  const dispatch = useDispatch();

  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );

  const profileNivelState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );

  function dispathData() {
    if (profileNivelState.nivel !== 2) {
      dispatch(
        getClients(
          profileNivelState.idLegado,
          clientsFilterState.account,
          clientsFilterState.initialDate,
          clientsFilterState.finalDate,
          clientsFilterState.ownership,
          clientsFilterState.status
        )
      );
    } else {
      dispatch(
        getClients(
          clientsFilterState.partner,
          clientsFilterState.account,
          clientsFilterState.initialDate,
          clientsFilterState.finalDate,
          clientsFilterState.ownership,
          clientsFilterState.status
        )
      );
    }
  }

  function searchFare() {
    if (
      moment(clientsFilterState.initialDate) >
      moment(clientsFilterState.finalDate)
    ) {
      return Swal.fire({
        icon: 'error',
        title: 'A data inicial não pode ser maior que a data final!',
        confirmButtonText: 'Tentar novamente',
      });
    }
    return dispathData();
  } 

  return (
    <Filter.Default>
      <SetPartner />
      <SetOwnership />
      <SetStatus />
      <SetAccountType />
      <SetFinalDate />
      <SearchButton
        onClick={() => searchFare()}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default ClientsFilter;
